<template>
  <div class="single-video">
    <div class="single-video__inner">
      <video ref="video" class="single-video__media" muted loop playsinline autoplay preload="none" poster="@/assets/videos/pyro-poster.jpg">
        <source :src="webm" type="video/webm">
        <source :src="mp4" type="video/mp4">
      </video>
    </div>
  </div>
</template>

<script>
  //import ScrollMagic from 'scrollmagic';
  //import 'ScrollMagicIndicators';

  export default {
    props: {
      webm: {
        type: String,
        required: false,
      },
      mp4: {
        type: String,
        required: false,
      },
    },
    /*
    data() {
      return {
        scene: null,
        node: null,
      };
    },
    mounted() {
      this.node = this.$refs['video'];
      let control = new ScrollMagic.Controller();

      this.node.pause();

      this.scene = new ScrollMagic.Scene({
        duration: () => this.node.clientHeight,
        triggerElement: this.node,
      })
      .on('enter', () => this.node.play())
      .on('leave', () => this.node.pause())
      .addIndicators({ name: 'that-video' })
      .addTo(control);
    }
    */
  };
</script>

<style lang="scss">
  @import 'scss/base';

  .single-video {
    position: fixed;
    top: 0;
    z-index: -1;
    width: 100%;
    left: 0;
    right: 0;
  }

  .single-video__inner {
    position: relative;
    overflow: hidden;

    video {
      height: 100vh;
      object-fit: cover;
      width: 100%;
    }
  }

  .single-video__media {
    display: block;
    width: 100%;
  }
</style>